import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import FileIcon, { defaultStyles } from 'react-file-icon';
import { SizedImage, RESPONSIVE_SIZES_FIGURE } from './Image';

const styles = theme => ({
  default: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%,-50%)',
  },
  imageModal: {
    width: '100%%',
    height: '100%',
    margin: 'auto',
    position: 'relative',
    '@global img': {
      position: 'absolute',
      width: '70%',
      left: '50%',
      top: '50%',
      transform: 'translate(-50%,-50%)',
    },
    padding: theme.spacing(10),
  },
});

class File extends React.Component {
  static propTypes = {
    classes: PropTypes.object.isRequired,
    type: PropTypes.string.isRequired,
    item: PropTypes.object.isRequired,
    className: PropTypes.string,
    noMinifcation: PropTypes.bool,
    noInteraction: PropTypes.bool,
    refreshId: PropTypes.string,
  };
  static defaultProps = {
    className: null,
    noMinifcation: false,
    noInteraction: false,
    refreshId: null,
  };

  state = {
    isOpen: false,
  };

  get extension() {
    const { item } = this.props;
    return item.originalFilename.match(/\.([0-9a-z]+)(?:[\?#]|$)/i)[1];
  }

  toggleIsOpen = () => {
    if (this.props.noInteraction) return;
    this.setState(state => ({
      isOpen: !state.isOpen,
    }));
  };

  render() {
    const { classes, type, className, item, refreshId } = this.props;
    const { isOpen } = this.state;
    let assetId = item.uuid;
    switch (type) {
      case 'application/pdf':
        return (
          <object
            scrolling="no"
            data={`/ada-assets/${item.uuid}`}
            width="100%"
            height="500px"
            type="application/pdf"
          />
        );
      case 'image/jpg':
      case 'image/jpeg':
      case 'image/png':
      case 'image/gif':
      case 'image/svg+xml':
        if (refreshId) {
          assetId += `?refreshId=${refreshId}`;
        }
        return (
          <SizedImage
            assetId={assetId}
            alt={item.altText}
            sizes={RESPONSIVE_SIZES_FIGURE}
          />
        );
      default:
        return (
          <div className={classes.default}>
            <FileIcon
              size={100}
              extension={this.extension}
              {...defaultStyles[this.extension]}
            />
          </div>
        );
    }
  }
}

export default withStyles(styles)(File);
